module.exports = __webpack_public_path__ + "static/media/rock.a367d6ea.svg";